import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default new class Counter {
  initCounter() {
    if ($('.js-counter').length > 0) {
      $('.js-counter').each(function (i, el) {
        var initVal = $(el).data('from');
        var lastVal = $(el).data('to');
        el.innerHTML = initVal;

        let count = $(this),
          zero = { val: 0 },
          num = lastVal,
          split = (num + '').split('.'),
          decimals = split.length > 1 ? split[1].length : 0;

        gsap.to(zero, {
          val: num,
          duration: 2,
          scrollTrigger: el,
          onUpdate: function () {
            count.text(zero.val.numberFormat(decimals));
          },
        });
      });
    }
  }

}

Number.prototype.numberFormat = function (decimals, dec_point, thousands_sep) {
  if (document.documentElement.lang == 'en-BE') {
    dec_point = typeof dec_point !== 'undefined' ? dec_point : '.';
    thousands_sep = typeof thousands_sep !== 'undefined' ? thousands_sep : ',';
  } else {
    dec_point = typeof dec_point !== 'undefined' ? dec_point : ',';
    thousands_sep = typeof thousands_sep !== 'undefined' ? thousands_sep : '.';
  }

  var parts = this.toFixed(decimals).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_sep);

  return parts.join(dec_point);
}

